import type { SanityPortableText } from '@libs/ui';

export const enum PremadeTripType {
  PublishedInSanity = 'publishedInSanity',
  AI = 'ai',
}

export interface AITripDestination {
  name: string;
  activityTexts: string[];
}

export interface AITripDescription {
  mainText: string;
  destinations: AITripDestination[];
}

export interface AIPremadeTrip {
  type: PremadeTripType.AI;
  headline: string;
  description: AITripDescription;
  imageUrl: string;
}

export type AIPremadeTripWithOptionalImageUrl = Omit<
  AIPremadeTrip,
  'imageUrl'
> & { imageUrl: string | undefined };

export interface SanityPremadeTrip {
  type: PremadeTripType.PublishedInSanity;
  headline: string;
  description: SanityPortableText[];
  imageUrl: string;
}

export type PremadeTrip = AIPremadeTrip | SanityPremadeTrip;

export interface PriceGuaranteeModalData {
  title?: string;
  description?: string;
}
